import axios from "./axios";

/**
 * [XSAPI] Game - game list 조회
 * @returns
 */
export const requestGameList = async () => {
  let response = null;

  try {
    response = await axios.get("/games/list");
  } catch (error) {
    throw new Error(error);
  }
  return response;
};
